import { Controller } from "@hotwired/stimulus"

const THEMES = {
  light: { plain: "lofi", warm: "sepia" },
  dark: { plain: "business", warm: "umber" }
}

export default class extends Controller {
  static targets = ["surface"]

  connect() {
    this.media = window.matchMedia("(prefers-color-scheme: dark)")
    this.preference = localStorage.getItem("draftlight-theme") || "system"
    this.surface = localStorage.getItem("draftlight-surface") || "plain"
    this.apply()
    this.handleSystemChange = () => this.preference === "system" && this.apply()
    this.media.addEventListener("change", this.handleSystemChange)
  }

  disconnect() {
    this.media?.removeEventListener("change", this.handleSystemChange)
  }

  surfaceTargetConnected(select) {
    select.value = this.surface
  }

  toggle() {
    this.preference = this.darkActive() ? "light" : "dark"
    localStorage.setItem("draftlight-theme", this.preference)
    this.apply()
  }

  changeSurface(event) {
    this.surface = event.target.value in THEMES.light ? event.target.value : "plain"
    localStorage.setItem("draftlight-surface", this.surface)
    this.apply()
  }

  darkActive() {
    return this.preference === "dark" || (this.preference === "system" && this.media.matches)
  }

  apply() {
    const mode = this.darkActive() ? "dark" : "light"
    const surface = this.surface in THEMES[mode] ? this.surface : "plain"
    document.documentElement.dataset.theme = THEMES[mode][surface]
  }
}
